import { makeStyles } from '@material-ui/core';

export const styles = makeStyles((theme) => ({
    mobileContainer: {
        padding: '24px',
        background: '#f5f6fa',
        height: '100%'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    detailContainer: {
        paddingRight: '24px',
        background: '#fff'
    },
    addingReportButton: {
        marginTop: '30px'
    },
    submitReportButton: {
        backgroundColor: 'green !important',
        color: 'white !important'
    },

    uploadButton: {
        direction: 'ltr'
    },
    imgaeUpload: {
        //width: '70%',
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        direction: 'rtl'
    },
    header: {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'nowrap'
    },
    showImage: {
        marginTop: '40px',
        textAlign: 'center'
    },
    no__report__added: {
        margin: 'auto',
        textAlign: 'center',
        marginTop: '40vh',
        color: '#bbbbbb'
    },

    info__type: {
        fontSize: '17px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.23,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#363636',
        maxWidth: '300px',
        display: 'inline-block',
        [theme.breakpoints.down('md')]: {
            fontSize: '16px'
        }
    },
    actionButtonsContainer: () => ({
        position: 'absolute',
        right: '0',
        top: '0',
        display: 'flex',
        '& > div': {
            marginInlineStart: '16px'
        }
    }),
    info__trash__button: {
        [theme.breakpoints.up('lg')]: {
            marginRight: '12px'
        }
        // [theme.breakpoints.down('md')]: {
        //     marginRight:'22px'
        // }
    },
    info__locations: {},
    info__location: {
        marginBottom: '14px',
        fontSize: '15px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.23,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#363636',
        [theme.breakpoints.down('md')]: {
            fontFamily: 'inherit',
            fontSize: '14px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: '#363636'
        }
    },

    info__image: {
        borderRadius: '9px',
        border: 'solid 2px #dadada',
        backgroundColor: '#ffffff'
    },
    info__container: {
        direction: 'ltr',
        textAlign: 'left',
        // paddingRight: '24px',
        flexGrow: 1,

        maxWidth: '100% !important',

        [theme.breakpoints.down('sm')]: {
            flexGrow: 1,
            background: '#fff'
        },
        // padding: '25px 25px 0px 20px',
        [theme.breakpoints.down(1025)]: {
            padding: '24px'
        }
    },
    mainInfoContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingInlineEnd: '72px',
        position: 'relative',
        marginBottom: '26px'
    },
    info__date: {
        // marginTop: '25px',
        fontSize: '15px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.23,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#363636',
        display: 'inline-flex',
        flexDirection: 'row',
        margin: '0 27px',
        '& > div': {
            marginInlineEnd: '13px'
        },
        [theme.breakpoints.down(1025)]: {
            fontFamily: 'inherit',
            fontSize: '14px',
            lineHeight: '1.5',
            textAlign: 'left',
            color: '#363636',
            whiteSpace: 'nowrap',
            margin: '0',
            float: 'right'
        }
    }
}));
